'use strict';

module.exports = {
    /**
     * 获取地理位置接口<br />
     * 对应native接口：geolocation.getCurrentPosition
     * @method hysdk.getLocation
     * @category Device
     * @example ./getLocation.js[1-25]
     * @description
     *
     * | 参数 | 类型 | 描述 | 必选 | 注明 |
     * | :--: | :--: | :--: | :--: | :--: |
     * | type | String | 坐标类型 | X | 非常用参数，仅微信支持，默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02' |
     * | timeout | Number | 超时设置 | X | 非常用参数，当定位时间超出此限制时，调用失败回调。单位：ms |
     * | maximumAge | Number | 缓存定位结果时间 | X | 非常用参数，可以接受的缓存定位结果时间，当上次定位的时间距今在设定值的范围内，则直接使用上次的定位结果。可用于快速定位、对精度要求不高的场景。单位：ms |
     * | success | Function | success 回调 | X | 常用参数 |
     * | fail | Function | fail 回调 | X | 常用参数 |
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | √    |
     * | touch   |   √ (https) |
     * | wechat  |   √   |
     * | ctrip   |   √   |
     *
     */
    getLocation: {
        hy: {
            key: 'geolocation.getCurrentPosition'
        },
        wechat: {
            successHandle: function successHandle(ret) {
                return {
                    type: 'wechat',
                    coords: {
                        latitude: ret.latitude,
                        longitude: ret.longitude
                    }
                };
            }
        },
        h5: {
            // 新版chrome要求：getCurrentPosition()和watchPosition() 不再支持http等非安全协议.
            handle: function handle() {
                var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (data) {
                        opt.success({
                            type: 'h5',
                            coords: data.coords
                        });
                    }, opt.fail, {
                        enableHighAccuracy: !!opt.enableHighAccuracy,
                        timeout: opt.timeout || 5000
                    });
                } else {
                    opt.fail({
                        ret: false,
                        errcode: -1,
                        errmsg: 'Geolocation is not supported!'
                    });
                }
            }
        }
    },
    /**
     * 使用经纬度打开地图<br />
     * 对应native接口：openLocation
     * @method hysdk.openLocation
     * @category Device
     * @example ./openLocation.js[1-12]
     * @description
     *
     * | 参数 | 类型 | 描述 | 必选 | 注明 |
     * | :--: | :--: | :--: | :--: | :--: |
     * | longitude | String | 经度 | √ | 常用参数，范围为180 ~ -180
     * | latitude  | String | 纬度 | √ | 常用参数，范围为90 ~ -90
     * | name | String | 位置名 | X | 非常用参数，仅微信支持 |
     * | address | String | 地址详情说明 | X | 非常用参数，仅微信支持 |
     * | scale | Number | 地图缩放级别 | X | 范围从1~28。默认为最大，非常用参数，仅微信支持 |
     * | infoUrl | String | 在查看位置界面底部显示的超链接,可点击跳转 | X | 非常用参数，仅微信支持 |
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   √   |
     *
     */
    openLocation: {
        hy: {
            //TODO Android是否支持？
            key: 'openLocation'
        },
        wechat: {
            key: 'openLocation'
        }
    },
    /**
     * 获取设备信息<br />
     * 对应native接口：native.getDeviceInfo
     * @method hysdk.getDeviceInfo
     * @category Device
     * @example ./getDeviceInfo.js[1-25]
     * @description
     *
     * | 参数 | 类型 | 描述 | 必选 | 注明 |
     * | :--: | :--: | :--: | :--: | :--: |
     * | hybridId | String | hybridId | X | 大客户端不用，可不填 |
     * | success | Function | success 回调 | X | 常用参数 |
     * | fail | Function | fail 回调 | X | 常用参数 |
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     * 苹果设备 model 映射关系请参考<a href="http://ued.qunar.com/hy2/hysdk/appendix.html#苹果设备映射表" target="_blank">附录</a>
     */
    getDeviceInfo: {
        hy: {
            key: 'native.getDeviceInfo'
        }
    },
    /**
     * 获取网络状态<br />
     * 对应native接口：network.getType
     * @method hysdk.getNetworkType
     * @category Device
     * @example ./getNetworkType.js[1-12]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | √    |
     * | touch   |   X  |
     * | wechat  |   √   |
     * | ctrip   |   √   |
     *
     */
    getNetworkType: {
        hy: {
            key: 'network.getType'
        },
        wechat: {
            successHandle: function successHandle(ret) {
                return {
                    networkType: ret.networkType
                };
            }
        }
    },
    /**
     * 注册截屏监听，一定要配合 onReceiveScreenshot 一起使用<br />
     * 对应native接口：registerScreenshot
     * @method hysdk.registerScreenshot
     * @category Device
     * @example ./registerScreenshot.js[1-19]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | X   |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    registerScreenshot: {
        hy: {
            key: 'registerScreenshot'
        }
    },
    /**
     * 当页面退出，或者不需要截屏监听的时候，就需要移除这个监听了。<br />
     * 对应native接口：unregisterScreenshot
     * @method hysdk.unregisterScreenshot
     * @category Device
     * @example ./unregisterScreenshot.js[1-10]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    unregisterScreenshot: {
        hy: {
            key: 'unregisterScreenshot'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/apis/device.js
// module id = 14
// module chunks = 0 2 4